import logo from '../assets/img/Ai-Horizon-Logo.png'
import footerbgimg from '../assets/img/footerbgimg.jpg'
import { IoIosMail } from "react-icons/io";
import { CiLocationOn } from "react-icons/ci"
import "./Footer.css"

export default function Footer() {

    return (
        <>
            <div
                style={{
                    backgroundImage: `url(${footerbgimg})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPosition: `center`,
                }}
                className='footer-main-div'
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        paddingTop: '20px'
                    }}

                >
                    <div style={{ display: 'flex', justifyContent: 'space-around', width: '90%' }} className='footer-powerdby-quicklinks-contactus'>
                        <div className='footer-powerdby'>
                            <img src={logo} alt='logo' style={{ maxWidth: '75%', marginBottom: "35px" }} className='footer-img' />
                            <p style={{ fontFamily: 'sans-serif', color: '#fff', fontSize: '18px', fontWeight: '600', marginBottom: '15px' }}>Powered By</p>
                            <p style={{ fontFamily: 'sans-serif', color: '#fff', fontSize: '17px', fontWeight: '500' }}>Nexasprint Technologies Pvt. Ltd.</p>
                        </div>

                        <div style={{ color: '#fff', cursor: 'pointer', fontFamily: 'sans-serif' }} className='footer-quicklinks'>
                            <p style={{ color: '#F3A01E', fontSize: '20px', fontWeight: '600', marginBottom: '15px', textDecoration: 'underline' }}>Quick Links</p>
                            <p style={{ marginBottom: '20px' }} onClick={() => window.location.href = "https://ai-horizon.io/"}>Home</p>
                            <p style={{ marginBottom: '20px' }} onClick={() => window.location.href = "https://ai-horizon.io/about/"}>About Us</p>
                            <p style={{ marginBottom: '20px' }} onClick={() => window.location.href = "https://ai-horizon.io/platform/"}>Platform</p>
                            <p style={{ marginBottom: '20px' }} onClick={() =>  window.location.href = "https://ai-horizon.io/industries/"}>Industries</p>
                            <p style={{ marginBottom: '20px' }} onClick={() =>  window.location.href = "https://ai-horizon.io/blogs/"}>Blogs</p>
                            <p style={{ marginBottom: '20px' }} onClick={() =>  window.location.href = "https://ai-horizon.io/careers/"}>Careers</p>
                        </div>

                        <div style={{ color: '#fff', cursor: 'pointer', fontFamily: 'sans-serif', display: 'flex', flexDirection: 'column' }}>
                            <p style={{ color: '#F3A01E', fontSize: '20px', fontWeight: '600', marginBottom: '15px', textDecoration: 'underline' }}>Contact Us</p>
                            <div style={{ display: 'flex', }}>
                                <CiLocationOn style={{ color: '#F3A01E', marginRight: '15px', marginTop: '15px' }} />
                                <div>
                                    <p style={{ marginBottom: '5px', display: 'flex', flexWrap: 'wrap' }}>
                                        1306-07, C wing, Kailas Business Park, HMPL Surya
                                    </p>
                                    <p style={{ marginBottom: '20px', display: 'flex', flexWrap: 'wrap' }}>
                                        Nagar, Vikhroli West, Mumbai, Maharashtra 400079
                                    </p>
                                </div>
                            </div>
                            <p><IoIosMail style={{ color: '#F3A01E', marginRight: '15px' }} />info@ai-horizon.io</p>
                        </div>
                    </div>

                    <div style={{ border: '1px solid #17BCBC', width: '90%', marginTop: '20px' }} />

                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '90%', marginTop: '40px', marginBottom: '30px' }} className='footer-links'>
                        <p style={{ color: '#fff', fontWeight: '500', fontFamily: 'sans-serif', fontSize: '16px' }} className='footer-copright'>© {new Date().getFullYear()} All Rights Reserved. Nexasprint Technologies Pvt. Ltd.</p>
                        <div style={{ display: 'flex' }}>
                            <p style={{ marginRight: '20px', color: '#fff', fontWeight: '500', fontFamily: 'sans-serif', fontSize: '16px', cursor: 'pointer' }} onClick={() =>  window.location.href = "https://ai-horizon.io/privacy-policy/"}>Privacy Policy</p>
                            <p style={{ marginRight: '20px', color: '#fff', fontWeight: '500', fontFamily: 'sans-serif', fontSize: '16px', cursor: 'pointer' }} onClick={() =>  window.location.href = "https://ai-horizon.io/terms-and-conditions/"}>Terms and Conditions</p>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )

}
